import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BackupResource } from '../../resources/backup.resource';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { combineLatest, Subscription } from 'rxjs';
import { GlobalPropertiesContext } from '../../../shared/contexts/global-properties.context';

@Component({
  selector: 'ziro-admin-backup',
  templateUrl: './backups.component.html',
  styleUrls: ['./backups.component.scss', '../../admin-page.scss'],
  providers: [BackupResource],
  standalone: false,
})
export class BackupsComponent implements OnInit, OnDestroy {
  private backupResource = inject(BackupResource);
  private breadcrumbsService = inject(BreadcrumbsService);
  private globalPropertiesContext = inject(GlobalPropertiesContext);

  currentBackupUrl = `${window.location.origin}/services/system/admin/backups/current`;
  isLoading = true;
  isHostedEnabled: boolean;
  dailyBackupFileNames: string[];
  weeklyBackupFileNames: string[];
  ziroIcons = ZiroIcons;
  private _subscriptions = new Subscription();

  ngOnInit(): void {
    this.breadcrumbsService.updateBreadcrumbs([{ label: 'tkey;admin.backup.title' }]);

    const sub = combineLatest([
      this.globalPropertiesContext.state$,
      this.backupResource.getDailyBackups(),
      this.backupResource.getWeeklyBackups(),
    ]).subscribe(([globalProperties, dailyBackup, weeklyBackup]) => {
      this.isHostedEnabled = globalProperties.hostedEnabled;
      this.dailyBackupFileNames = dailyBackup;
      this.weeklyBackupFileNames = weeklyBackup;
      this.isLoading = false;
    });

    this._subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
    this._subscriptions.unsubscribe();
  }
}
